// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vx","left":"vy","center":"vz","right":"vA"};